
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function FormGroup (props)
{
    return (
	<Form.Group as={Row} className="align-items-center" controlId={props.formID + "." + props.controlID}>
	    <Form.Label column sm={props.sm} className="text-muted text-uppercase text-end py-0 lh-sm">{props.label}</Form.Label>
	    <Col sm={12-props.sm}>{props.children}</Col>
	</Form.Group>
    );
}

FormGroup.defaultProps = {
    label: "",
    sm: 4,
};
